import globals from "imports/globals";
import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

const component = (function () {
    $(document).ready(function () {
        if ($(".hero").length) {
            gsap.registerPlugin(ScrollTrigger);

            if (globals.debug) console.log("component-hero initialized");
            var instance = $(".hero");
            var globe = instance.find(".hero-globe");
            var wrapper = instance.find(".hero-scroll-wrapper");
            var type = instance.find(".hero-typography");

            var timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: wrapper[0],
                    start: "top top",
                    end: "bottom bottom",
                    scrub: 0.1,
                },
            });

            timeline
                .addLabel("start")
                .to(globe[0], { opacity: 1, y: "-60%", ease: "none" })
                .to(globe[0], { opacity: 1, y: "-120%", ease: "none" })
                .addLabel("end");

            var st = ScrollTrigger.create({
                trigger: wrapper[0],
                start: "top+=62.5% top",
                endTrigger: "html",
                end: "bottom top",
                onToggle: (self) => {
                    if (self.isActive) {
                        type.addClass("on");
                    } else {
                        type.removeClass("on");
                    }
                },
                // markers: true,
            });

            console.log(st);

            $(window).on("preloaderHidden", function () {
                $(".hero-globe img").addClass("on");
            });
        }
    });
})();

export default component;
